export enum Validator {
  Email = 'email',
  Address = 'address',
  Alphabet = 'alphabet',
  AlphaNumeric = 'alphaNumeric',
  Numeric = 'numeric',
  SensitiveCharacter = 'sensitiveCharacter',
}
